import * as tslib_1 from "tslib";
import { ChangeDetectorRef, EventEmitter, OnDestroy, OnInit, } from '@angular/core';
import { FormBuilder, Validators, } from '@angular/forms';
import { AppStateFacade } from '@app-state';
import { UiSettingForm } from '@components/ui-forms/ui-setting-form';
import UiValidators, { UI_EMAIL_DOMAIN_MAX_LENGTH, UI_EMAIL_HOST_MAX_LENGTH, UI_EMAIL_MAX_LENGTH, UI_NAME_LONG_MAX_LENGTH, UI_NAME_MAX_LENGTH, UI_SMTP_PASSWORD_MAX_LENGTH, } from '@validators';
import { takeUntil } from 'rxjs/operators';
var UiMailSettingsComponent = /** @class */ (function (_super) {
    tslib_1.__extends(UiMailSettingsComponent, _super);
    function UiMailSettingsComponent(_fb, cd, appState) {
        var _this = _super.call(this, cd, appState) || this;
        _this._fb = _fb;
        _this.smtpSettingChanged = new EventEmitter();
        _this._smtpSettingControls = [
            'smtpUseDefaultCredentials',
            'smtpEnableSsl',
            'smtpHost',
            'smtpPort',
            'smtpDomain',
            'smtpUsername',
            'smtpPassword',
            'defaultFromAddress',
            'defaultFromDisplayName',
        ];
        return _this;
    }
    UiMailSettingsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.formGroup = this._fb.group({
            'alertsEmailEnabled': [
                this.settings.mail.alertsEmailEnabled,
            ],
            'smtpHost': [
                this.settings.mail.smtpHost,
                Validators.compose([
                    UiValidators.whitespace,
                    Validators.maxLength(UI_EMAIL_HOST_MAX_LENGTH),
                ]),
            ],
            'smtpPort': [
                this.settings.mail.smtpPort,
                UiValidators.range(1, 65535, true),
            ],
            'smtpDomain': [
                this.settings.mail.smtpDomain,
                Validators.compose([
                    UiValidators.whitespace,
                    Validators.maxLength(UI_EMAIL_DOMAIN_MAX_LENGTH),
                ]),
            ],
            'smtpUsername': [
                this.settings.mail.smtpUsername,
                Validators.compose([
                    UiValidators.whitespace,
                    Validators.maxLength(UI_NAME_LONG_MAX_LENGTH),
                ]),
            ],
            'smtpPassword': [
                this.settings.mail.smtpPassword,
                UiValidators.maxLength(UI_SMTP_PASSWORD_MAX_LENGTH),
            ],
            'smtpUseDefaultCredentials': [
                this.settings.mail.smtpUseDefaultCredentials,
            ],
            'smtpEnableSsl': [
                this.settings.mail.smtpEnableSsl,
            ],
            'defaultFromAddress': [
                this.settings.mail.defaultFromAddress,
                Validators.compose([
                    UiValidators.maxLength(UI_EMAIL_MAX_LENGTH),
                    UiValidators.email(true),
                ]),
            ],
            'defaultFromDisplayName': [
                this.settings.mail.defaultFromDisplayName,
                Validators.compose([
                    UiValidators.whitespace,
                    Validators.maxLength(UI_NAME_MAX_LENGTH),
                ]),
            ],
        });
        var disabledControls = ['alertsEmailEnabled', 'smtpUseDefaultCredentials', 'smtpEnableSsl'];
        this.isReadOnly$
            .pipe(takeUntil(this._destroyed$))
            .subscribe(function (isReadOnly) {
            if (isReadOnly) {
                disabledControls.forEach(function (controlName) { return _this.formGroup.get(controlName).disable(); });
            }
            else {
                disabledControls.forEach(function (controlName) { return _this.formGroup.get(controlName).enable(); });
            }
        });
        this.formGroup.valueChanges
            .pipe(takeUntil(this._destroyed$))
            .subscribe(function (value) { return Object.assign(_this.settings.mail, value); });
    };
    UiMailSettingsComponent.prototype.toggleSmtpSettingChangeStatus = function () {
        var _this = this;
        this.smtpSettingChanged.emit(this._smtpSettingControls.some(function (controlName) { return _this.formGroup.get(controlName).dirty; }));
    };
    return UiMailSettingsComponent;
}(UiSettingForm));
export { UiMailSettingsComponent };
